import {DefinitionReturn} from "../types/DefinitionReturn";
import {FW_TOAST_BRAND} from "../enums/FWToastBrandEnum";

type InvalidAttachmentTypeToastType = {
    acceptedTypes: string,
    maxFileSize: number | string
}

export const INVALID_ATTACHMENT_TYPE_TOAST = (params: InvalidAttachmentTypeToastType): DefinitionReturn => ({
    templateProps: params,
    timeOut: 6000,
    type: FW_TOAST_BRAND.DANGER_FOR_INVALID_ATTACHMENT_TYPE
})